import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.request');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-request',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.request/view.scss */
/* src/app/portal.gsdcadmin.request/view.scss: no such file or directory */`],
})
export class PortalGsdcadminRequestComponent implements OnInit, OnDestroy {
    public requests: any[] = [];
    public loading: boolean = false;
    public role: string = '';
    public roleLabels: any = {admin:'시스템 관리자',manager:'서비스 담당자',leader:'커뮤니티 대표',pi:'그룹 대표(PI)',user:'개인연구자'};
    public selectedTab: string = 'signup';
    public scope = 'progress';
    public community = '';
    public communities: any[] = [];
    public loadFailed = false;
    private loadId = 0;
    public processing = false;
    public tabs: any[] = [
        { id: 'signup', label: '회원가입 요청' },
        { id: 'newGroup', label: '신규 그룹 생성 요청' },
        { id: 'joinGroup', label: '그룹 가입 요청' }
    ];

    public pagination = {
        current: 1,
        start: 1,
        end: 1,
        itemsPerPage: 10
    };
    public total: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");

        this.role = this.service.auth.session.role;
        const query = new URLSearchParams(window.location.search);
        this.selectedTab = query.get('tab') || 'signup';
        this.scope = query.get('scope') || 'progress';
        this.community = query.get('community') || '';
        this.pagination.current = Math.max(1,Number(query.get('page')) || 1);
        await this.loadRequests();
    }

    public ngOnDestroy() { this.loadId++; }

    public async setTab(tab: string) {
        this.selectedTab = tab;
        this.pagination.current = 1;
        await this.loadRequests();
    }

    public async filter() { this.pagination.current = 1; await this.loadRequests(); }
    public async loadRequests() {
        if (!this.tabs.some(tab => tab.id === this.selectedTab)) {
            this.selectedTab = 'signup';
            this.pagination.current = 1;
        }
        const id=++this.loadId;
        this.loading=true;this.loadFailed=false;
        await this.service.render();
        try {
            const params={page:this.pagination.current,tab:this.selectedTab,scope:this.scope,community:this.community};
            const {code,data}=await wiz.call('get_all_signup_requests',params);
            if(id!==this.loadId)return;
            if(code!==200 || !Array.isArray(data?.requests))throw new Error('load');
            this.requests=data.requests;this.communities=data.communities || [];
            this.pagination.current=data.page || this.pagination.current;
            this.pagination.start=Math.floor((this.pagination.current-1)/10)*10+1;
            this.pagination.end=Math.max(1,data.lastpage || 1);this.total=data.total;
            const url=new URL(window.location.href);
            for(const [key,value] of Object.entries({...params,page:this.pagination.current}))value===''?url.searchParams.delete(key):url.searchParams.set(key,String(value));
            window.history.replaceState(window.history.state,'',url.toString());
        } catch(_) {if(id===this.loadId){this.loadFailed=true;this.requests=[];}}
        finally {if(id===this.loadId){this.loading=false;await this.service.render();}}
    }

    public async changePage(page: number) {
        this.pagination.current = page;
        await this.loadRequests();
    }

    public async approveRequest(id: string) { await this.processRequest(id, 'approve_request'); }
    public async rejectRequest(id: string) { await this.processRequest(id, 'reject_request'); }
    private async processRequest(request_id: string, action: string) {
        if(this.processing)return;
        this.processing=true;
        try {
            const approve=action==='approve_request';
            const row=this.requests.find(request=>request.id===request_id);
            const direct=approve && row?.admin_direct === true;
            const skipRepresentative=approve && row?.manager_skip_representative === true;
            const confirmation=approve && row?.status === 'D' ? '중단되거나 실패한 가입·그룹 처리를 이어서 진행하시겠습니까?' : direct ? '중간 승인 단계를 생략하고 최종 승인하시겠습니까?' : skipRepresentative
                ? (row?.manager_skip_pi
                    ? '그룹 대표(PI) 승인과 남은 중간 승인 단계를 생략하고 최종 승인하여 계정을 생성하시겠습니까?'
                    : row?.source === 'group'
                    ? '커뮤니티 대표 승인을 생략하고 연구그룹을 생성하며 신청자를 그룹 대표(PI)로 지정하시겠습니까?'
                    : '커뮤니티 대표 승인을 생략하고 최종 승인하여 계정을 생성하시겠습니까?') : '승인하시겠습니까?';
            const confirmed=approve ? await this.service.alert.success(confirmation,'취소') : await this.service.alert.error('거절하시겠습니까?','취소');
            if(!confirmed)return;
            this.service.loading.show();
            const payload: any={request_id,tab:this.selectedTab};
            if(skipRepresentative)payload.skip_representative='1';
            const {code,data}=await wiz.call(action,payload,{timeout:135000});
            this.service.loading.hide();
            const message = typeof data === 'string' ? data : data?.message;
            if(code!==200)throw new Error(message || '요청 처리에 실패했습니다.');
            await this.service.alert.success(message || (approve?'요청이 승인되었습니다.':'요청이 거절되었습니다.'));
            await this.loadRequests();
        } catch(error) {
            this.service.loading.hide();
            await this.loadRequests();
            await this.service.alert.error(error.message || '처리 결과를 확인하지 못했습니다. 목록을 확인한 후 다시 시도해주세요.');
        } finally {this.processing=false;this.service.loading.hide();await this.service.render();}
    }
}

export default PortalGsdcadminRequestComponent;